var _style, _path, _circle, _circle2, _circle3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 275.4 275.5",
    style: {
      enableBackground: "new 0 0 275.4 275.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6E6E6;}\n\t.st1{fill:#CCCCCC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.6,4.7L149.6,4.7c8.8-8.1,22.9-5.3,27.9,5.6l0,0c3.8,8.4,13.5,12.3,22.1,9.1l0,0 c11.2-4.2,23.2,3.9,23.7,15.8v0c0.3,9.2,7.7,16.5,16.9,16.9h0c12,0.5,20,12.5,15.8,23.7l0,0c-3.2,8.6,0.8,18.2,9.1,22.1l0,0 c10.9,5,13.7,19.1,5.6,27.9l0,0c-6.2,6.7-6.2,17.2,0,23.9l0,0c8.1,8.8,5.3,22.9-5.6,27.9l0,0c-8.4,3.8-12.3,13.5-9.1,22.1l0,0 c4.2,11.2-3.9,23.2-15.8,23.7h0c-9.2,0.3-16.5,7.7-16.9,16.9v0c-0.5,12-12.5,20-23.7,15.8l0,0c-8.6-3.2-18.2,0.8-22.1,9.1l0,0 c-5,10.9-19.1,13.7-27.9,5.6l0,0c-6.7-6.2-17.2-6.2-23.9,0l0,0c-8.8,8.1-22.9,5.3-27.9-5.6l0,0c-3.8-8.4-13.5-12.3-22.1-9.1l0,0 c-11.2,4.2-23.2-3.9-23.7-15.8v0c-0.3-9.2-7.7-16.5-16.9-16.9h0c-12-0.5-20-12.5-15.8-23.7l0,0c3.2-8.6-0.8-18.2-9.1-22.1l0,0 c-10.9-5-13.7-19.1-5.6-27.9l0,0c6.2-6.7,6.2-17.2,0-23.9l0,0c-8.1-8.8-5.3-22.9,5.6-27.9l0,0c8.4-3.8,12.3-13.5,9.1-22.1l0,0 c-4.2-11.2,3.9-23.2,15.8-23.7h0c9.2-0.3,16.5-7.7,16.9-16.9v0c0.5-12,12.5-20,23.7-15.8l0,0c8.6,3.2,18.2-0.8,22.1-9.1l0,0 c5-10.9,19.1-13.7,27.9-5.6l0,0C132.4,10.9,142.8,10.9,149.6,4.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 137.6,
    cy: 137.7,
    r: 120.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 137.6,
    cy: 137.7,
    r: 102.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 137.6,
    cy: 137.5,
    r: 66.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.4,92.3c-8-14.6-19.7-26.9-34-35.5c-14.2-8.6-30.9-13.6-48.8-13.6c-17.8,0-34.5,5-48.8,13.6 c-14.2,8.6-26,20.9-34,35.5L67.2,99C74,86.5,84,76,96.1,68.7c12.1-7.3,26.3-11.6,41.5-11.6c15.2,0,29.4,4.2,41.5,11.6 c12.1,7.3,22.1,17.8,28.9,30.3L220.4,92.3L220.4,92.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.9,182.4c8,14.6,19.7,26.9,34,35.5c14.2,8.6,30.9,13.6,48.8,13.6c17.8,0,34.5-5,48.8-13.6 c14.2-8.6,26-20.9,34-35.5l-12.3-6.7c-6.8,12.5-16.8,22.9-28.9,30.3c-12.1,7.3-26.3,11.6-41.5,11.6c-15.2,0-29.4-4.2-41.5-11.6 C84,198.6,74,188.1,67.2,175.7L54.9,182.4L54.9,182.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeGrey);
export default __webpack_public_path__ + "static/media/badge_grey.e70ae250522b42a448506ada03a88380.svg";
export { ForwardRef as ReactComponent };